import { Component, inject } from '@angular/core';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { CoreLibModalComponent } from '../modal/modal.component';

@Component({
  selector: 'mh-core-lib-session-revoked-modal',
  standalone: false,
  templateUrl: './session-revoked-modal.component.html',
})
export class CoreLibSessionRevokedModalComponent extends CoreLibModalComponent {
  constructor() {
    super(inject(DialogRef), inject(DIALOG_DATA));
  }
}
